<template>
  <ConfigLayout current="user">
    <ConfigPage title="ログインユーザー設定">
      <template slot="header">
        <Button flat :disabled="userList.length >= 20" @click="userAddModal = true"><AddStrongIcon />新規</Button>
      </template>
      <DataTable
        :data="userList"
        :columns="[{ key: 'mail', name: 'ログインID' }]"
        :minItemHeight="56"
        :loading="busy"
        :deleteButton="item => item.mail !== currentUser.mail"
        @delete="onDelete"
      >
      </DataTable>
      <Modal v-if="userAddModal" title="新規ログインユーザーの追加" @close="close">
        <FormGrid>
          <dt>メールアドレス<br />（ログインID）</dt>
          <dd>
            <TextInput placeholder="メールアドレス" v-model.trim="mail" />
          </dd>
        </FormGrid>
        <p>※ご登録のメールアドレスに、パスワード設定のご案内メールをお送りいたします。</p>
        <template #footer-center>
          <Button @click="close">戻る</Button>
          <Button primary :disabled="!mail" @click="addUser">追加</Button>
        </template>
      </Modal>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import DataTable from '@/components/molecules/DataTable'
import Modal from '@/components/molecules/Modal'
import FormGrid from '@/components/molecules/FormGrid'
import TextInput from '@/components/atoms/TextInput'
import Dialog from '@/components/molecules/ModalDialog'
import AddStrongIcon from '@/components/icons/addStrong'

export default {
  name: 'Options',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    DataTable,
    Modal,
    FormGrid,
    TextInput,
    AddStrongIcon,
  },
  data() {
    return {
      userAddModal: false,
      mail: '',
    }
  },
  computed: {
    ...mapState({
      userList: state => state.user.userList,
      busy: state => state.user.busy,
      currentUser: state => state.users.current.user,
    }),
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('user/get')
    },
    async onDelete({ id, mail }) {
      if (
        (await Dialog.confirm({
          title: 'ログインユーザー削除',
          message: '以下のご登録メールアドレスを\n削除してよろしいですか？',
          target: mail,
          caution: true,
          cancelText: '戻る',
          okText: '削除',
        })) &&
        (await this.$store.dispatch('user/delete', id))
      ) {
        this.fetch()
      }
    },
    async addUser() {
      this.userAddModal = false
      if (
        (await Dialog.confirm({
          title: '新規ログインユーザー追加',
          message: '以下のメールアドレスに\nパスワード設定のご案内メールをお送りいたします。',
          target: this.mail,
          cancelText: 'キャンセル',
          okText: '送信',
        })) &&
        (await this.$store.dispatch('user/register', this.mail)) &&
        (await Dialog.show({
          title: '送信完了',
          message: '以下のメールアドレスに\nパスワード設定のご案内メールをお送りしました。',
          target: this.mail,
          okText: '閉じる',
        }))
      ) {
        this.fetch()
      }
      this.mail = ''
    },
    close() {
      this.userAddModal = false
      this.mail = ''
    },
  },
}
</script>
